import React, { useState, useRef, useEffect } from "react";
import { Globe, CaretDown, Check } from "@phosphor-icons/react";
import { useI18n } from "../contexts/I18nContext";

export default function LanguagePicker({ variant = "dark" }) {
  const { locale, setLocale } = useI18n();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const isDark = variant === "dark";

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 text-[10px] font-bold tracking-[0.1em] uppercase rounded-full px-3 py-1.5 transition-colors border ${
          isDark
            ? "text-white/80 hover:text-white border-white/20 hover:border-white/40 bg-white/5"
            : "text-[#02371b]/80 hover:text-[#02371b] border-[#02371b]/20 hover:border-[#02371b]/40 bg-[#02371b]/5"
        }`}
      >
        <Globe size={14} weight="bold" />
        <span>{locale === "en" ? "English" : "Русский"}</span>
        <CaretDown size={10} weight="bold" />
      </button>
      
      {open && (
        <div 
          className={`absolute right-0 top-full mt-2 w-36 border rounded-xl shadow-2xl overflow-hidden z-50 py-1 ${
            isDark ? "bg-[#02371b] border-white/10" : "bg-white border-neutral-200"
          }`}
        >
          <button
            type="button"
            onMouseDown={(e) => { e.preventDefault(); setLocale("en"); setOpen(false); }}
            className={`w-full flex items-center justify-between px-4 py-2.5 text-xs text-left transition-colors ${
              isDark ? "text-white/90 hover:bg-white/10 hover:text-white" : "text-neutral-700 hover:bg-neutral-50"
            }`}
          >
            <span>English</span>
            {locale === "en" && <Check size={12} weight="bold" className="text-[#41a42b]" />}
          </button>
          <button
            type="button"
            onMouseDown={(e) => { e.preventDefault(); setLocale("ru"); setOpen(false); }}
            className={`w-full flex items-center justify-between px-4 py-2.5 text-xs text-left transition-colors ${
              isDark ? "text-white/90 hover:bg-white/10 hover:text-white" : "text-neutral-700 hover:bg-neutral-50"
            }`}
          >
            <span>Русский</span>
            {locale === "ru" && <Check size={12} weight="bold" className="text-[#41a42b]" />}
          </button>
        </div>
      )}
    </div>
  );
}
